import { Loadable, LoadableFactory } from '®shared/data';

import { CurrentUserAndPermissions } from './current-user-and-permissions';

export type CurrentUserState = {
  accessToken: string | null;
  loadableUser: Loadable<CurrentUserAndPermissions>;
};

export const CURRENT_USER_INITIAL_STATE: CurrentUserState = {
  accessToken: null,
  loadableUser: LoadableFactory.reset(),
};
